import React, { useEffect } from 'react'
import AOS from 'aos'
import { Button, Col, Container, Row, Stack } from 'react-bootstrap'
import { Link } from 'react-router-dom';


const Service = () => {

    useEffect(() => {
        AOS.init({ duration: 2000 })
    });
    return (
        <>
            <div className="ServiceContainer mt-5 mb-5">
                <div className="ServiceContent mt-4 mb-4">
                    <Container data-aos="fade-up">
                        <h1 className='text-center mt-3 fontWeight-800'>Take A Glimpse At Our Services</h1>
                        <h5 className='mb-5'>Explore Futurristic's array of innovative services designed to propel your vision forward.</h5>
                        <Row>
                            <Col md={4} sm={12}>
                                <div className="ServiceCard mb-4">
                                    <div className="Part 01">
                                        <Stack direction='vertical' gap={2}>
                                            <img src="https://futurristic-prod.s3.ap-south-1.amazonaws.com/image/icon/01-Service.png" alt="metaverse-service-01-futurristic" className="img-fluid serviceIcon mx-auto" />
                                            <h4>Metaverse Services and <br />Solution</h4>
                                            <p className='  text-grey-500'>Supercharge your digital presence & immerse your audience with tailored Metaverse solutions, from virtual spaces to interactive engagement, redefining experiences.</p>
                                            <Link to='/metaverse-end-to-end-solutions' target='_blank'>
                                                <Button className='rounded-5 ContactBtn  mobile-100' variant='dark' type='submit'>Learn More</Button>
                                            </Link>
                                        </Stack>
                                    </div>
                                </div>
                            </Col>
                            <Col md={4} sm={12}>
                                <div className="ServiceCard mb-4">
                                    <div className="Part 02">
                                        <Stack direction='vertical' gap={2}>
                                            <img src="https://futurristic-prod.s3.ap-south-1.amazonaws.com/image/icon/02-Service.png" alt="metaverse-service-02-futurristic" className="img-fluid serviceIcon mx-auto" />
                                            <h4>Web AR-Based Marketing<br /> Solutions</h4>
                                            <p className='  text-grey-500'>Sell digital goods by engaging customers using immersive, interactive experiences accessible directly through web browsers. Transform product marketing today!</p>
                                            <Link to='/web-ar-based-marketing-solutions' target='_blank'>
                                                <Button className='rounded-5  ContactBtn  mobile-100' variant='dark' type='submit'>Learn More</Button>
                                            </Link>
                                        </Stack>
                                    </div>
                                </div>
                            </Col>
                            <Col md={4} sm={12}>
                                <div className="ServiceCard mb-4">
                                    <div className="Part 03">
                                        <Stack direction='vertical' gap={2}>
                                            <img src="https://futurristic-prod.s3.ap-south-1.amazonaws.com/image/icon/03-Service.png" alt="metaverse-service-03-futurristic" className="img-fluid serviceIcon mx-auto" />
                                            <h4>Blockchain Integration Services & Solutions</h4>
                                            <p className='  text-grey-500'>Integrate blockchain into your existing business processes & IT systems for heightened security & efficiency gains. Enhance transparency, reduce fraud, and streamline operations. </p>
                                            <Link to='/blockchain-integration-and-solutions' target='_blank'>
                                                <Button className='rounded-5  ContactBtn mobile-100' variant='dark' type='submit'>Learn More</Button>
                                            </Link>
                                        </Stack>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={4} sm={12}>
                                <div className="ServiceCard mb-4">
                                    <div className="Part 04">
                                        <Stack direction='vertical' gap={2}>
                                            <img src="https://futurristic-prod.s3.ap-south-1.amazonaws.com/image/icon/04-Service.png" alt="metaverse-service-04-futurristic" className="img-fluid serviceIcon mx-auto" />
                                            <h4>Immersive Technologies Services and Solutions</h4>
                                            <p className='text-grey-500'>Create immersive AR, VR, and MR experiences to enhance training, product visualization, and collaboration with cutting-edge technology.</p>
                                            <Link to='/immersive-technologies-services-and-solutions-ar-vr-mr-xr' target='_blank'>
                                                <Button className='rounded-5  ContactBtn mobile-100' variant='dark' type='submit'>Learn More</Button>
                                            </Link>
                                        </Stack>
                                    </div>
                                </div>
                            </Col>
                            <Col md={4} sm={12}>
                                <div className="ServiceCard mb-4">
                                    <div className="Part 05">
                                        <Stack direction='vertical' gap={2}>
                                            <img src="https://futurristic-prod.s3.ap-south-1.amazonaws.com/image/icon/05-Service.png" alt="metaverse-service-05-futurristic" className="img-fluid serviceIcon mx-auto" />
                                            <h4>Interactive AR/VR/XR Game Development </h4>
                                            <p className='  text-grey-500'>Design & develop an AR/VR/XR game app for any platform with a clear game concept, graphics, storyline, & core mechanics, ensuring immersive experiences.</p>
                                            <Link to='/game-development-services-&-solutions' target='_blank'>
                                                <Button className='rounded-5   ContactBtn mobile-100' variant='dark' type='submit'>Learn More</Button>
                                            </Link>
                                        </Stack>
                                    </div>
                                </div>
                            </Col>
                            <Col md={4} sm={12}>
                                <div className="ServiceCard mb-4">
                                    <div className="Part 06">
                                        <Stack direction='vertical' gap={2}>
                                            <img src="https://futurristic-prod.s3.ap-south-1.amazonaws.com/image/icon/06-Service.png" alt="metaverse-service-06-futurristic" className="img-fluid serviceIcon mx-auto" />
                                            <h4>Mobile Web & Enterprise Development </h4>
                                            <p className='  text-grey-500'>Forge powerful mobile web and enterprise solutions. Reach diverse audiences across devices to enhance business functionality & scalability. </p>
                                            <Link to='/mobile-web-&-enterprise-development' target='_blank'>
                                                <Button className='rounded-5  ContactBtn mobile-100' variant='dark' type='submit'>Learn More</Button>
                                            </Link>
                                        </Stack>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </Container>
                </div>
            </div>
        </>
    )
}

export default Service;
